import styled from "styled-components";

export const VoucherPageStyle = styled.div`

`;
